.formControlLabel {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  vertical-align: middle;
  -webkit-tap-highlight-color: transparent;
  margin-left: -11px;
  margin-right: 16px;
}

.start {
  flex-direction: row-reverse;
  margin-left: 16px;
  margin-right: -11px;
}

.top {
  flex-direction: column-reverse;
  margin-left: 16px;
}

.bottom {
  flex-direction: column;
  margin-left: 16px;
}

.labelText {
  font-family: var(--tuna-typography-fontFamily);
  font-size: var(--tuna-typography-body1-fontSize);
}
